export default {
    url: '/add',
    template: `
        <manage-settings-tasklist-templates-add
            tasklist-template="vm.tasklistTemplate"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
        />`,
    resolve: {
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (TasklistTemplateResource, classifiers, CLASSIFIER_ENUM) {
        this.tasklistTemplate = new TasklistTemplateResource();
        this.departments = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/tasklist/templates/add/index.js